// When custom endAdornment is added to size={'small'} Autocomplete TextField, it clashes with the select/clear
export default function TextField(theme) {
    return {
        MuiTextField: {
            styleOverrides: {
                root: ({ ownerState, variant })=>{
                    return {
                        variants: [
                            {
                                props: {
                                    size: 'small'
                                },
                                style: {
                                    '& .MuiCircularProgress-root': {
                                        position: 'absolute',
                                        right: '35px'
                                    }
                                }
                            },
                            {
                                props: {
                                    variant: 'filled',
                                    'data-gef-variant': 'static'
                                },
                                style: {
                                    '& .MuiInputBase-root.Mui-disabled': {
                                        backgroundColor: theme.palette.background[50],
                                        '& input, & select': {
                                            textFillColor: theme.palette.text.primary
                                        }
                                    }
                                }
                            },
                            {
                                props: {
                                    'data-gef-variant': 'static',
                                    size: 'small'
                                },
                                style: {
                                    '& .MuiInputLabel-filled, & .MuiInputLabel-root.MuiInputLabel-filled': {
                                        marginBottom: 2
                                    },
                                    '& input, & .MuiFilledInput-input': {
                                        paddingLeft: theme.spacing(1)
                                    },
                                    '& .MuiInputBase-root': {
                                        fontSize: theme.typography.pxToRem(14),
                                        lineHeight: theme.typography.pxToRem(22),
                                        minHeight: 32
                                    }
                                }
                            }
                        ],
                        ...ownerState['data-gef-variant'] === 'static' && ownerState.size === 'small' && ownerState.select ? {
                            '& .MuiSvgIcon-root': {
                                right: '-1px'
                            }
                        } : {},
                        ...variant === 'standard' && !ownerState.inputProps?.autoComplete ? {
                            '& .MuiIconButton-root': {
                                // affects only the datepicker icon
                                // https://github.com/mui/mui-x/issues/14714
                                marginRight: '-9px'
                            }
                        } : {}
                    };
                }
            }
        }
    };
}
